var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8306 8.34109L16.2156 12.8376L17.3045 19.1934C17.349 19.4749 17.2379 19.749 17.0082 19.9194C16.8823 20.0157 16.7267 20.0601 16.5712 20.0601C16.4527 20.0601 16.3341 20.0305 16.223 19.9786L10.5191 16.9785L4.81513 19.9786C4.56327 20.112 4.26696 20.0897 4.03732 19.9194C3.80768 19.7564 3.69657 19.4749 3.74101 19.1934L4.82995 12.8376L0.222347 8.34109C0.0223383 8.14108 -0.0517389 7.85218 0.0371538 7.5855C0.126046 7.31883 0.355686 7.11882 0.637179 7.08178L7.01522 6.15581L9.8672 0.377794C10.1191 -0.125931 10.9487 -0.125931 11.1932 0.377794L14.0451 6.15581L20.4232 7.08178C20.7047 7.12622 20.9343 7.31883 21.0232 7.5855C21.1121 7.85218 21.038 8.14108 20.8306 8.34109Z",
    fill: "#F7971E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ccdbc23facc71dfce9d13a808db58cc0.svg";
export { ForwardRef as ReactComponent };